import React from 'react'
import styled from 'styled-components'
import hello from './../assets/hello@2x.png';
import me from './../assets/me@2x.jpg';

const Avatar = styled.div`
  background: transparent url(${me}) 50% 50% no-repeat;
  background-size: 100%;
  border-radius: 100%;
  height: 160px;
  margin: -20px 0 0;
  text-indent: -999rem;
  width: 160px;
`

const Hello = styled.div`
  background: transparent url(${hello}) 50% 50% no-repeat;
  background-size: cover;
  height: 80px;
  margin: 30px 0 0;
  width: 200px;
`

export default () => (
  <React.Fragment>
    <Avatar>Hello</Avatar>
    <Hello />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/pages/index.js